import script from "./LiteExamHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./LiteExamHistory.vue?vue&type=script&setup=true&lang=js"

import "./LiteExamHistory.vue?vue&type=style&index=0&id=6d744e47&lang=css"

const __exports__ = script;

export default __exports__